export default "__VITE_ASSET__CaTecqhr__"